/**
 * Цвета для отметки «едут вместе».
 *
 * В рабочей таблице, которую вели до этой системы, совместный выезд
 * отмечали заливкой ячейки: залил трёх человек голубым — значит, едут
 * одной машиной. Ни названий, ни списков — только цвет, и понятно с
 * одного взгляда на экран.
 *
 * Здесь те же цвета, снятые с той таблицы. Их девять: больше глаз не
 * различает в списке, меньше — начинает не хватать в день, когда машин
 * уходит пять.
 */
export interface TravelColor {
  hex: string;
  /** Название нужно, чтобы группа получила имя: «8 августа · голубые» */
  label: string;
}

export const TRAVEL_COLORS: readonly TravelColor[] = [
  { hex: '#4a86e8', label: 'синие' },
  { hex: '#00c2d1', label: 'голубые' },
  { hex: '#93c47d', label: 'зелёные' },
  { hex: '#b6d7a8', label: 'салатовые' },
  { hex: '#ffd966', label: 'жёлтые' },
  { hex: '#ff9900', label: 'оранжевые' },
  { hex: '#e06666', label: 'красные' },
  { hex: '#c27ba0', label: 'розовые' },
  { hex: '#8e7cc3', label: 'сиреневые' },
];
